import { html } from 'lit';
import { Pen } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-edit')
export class PdsIconEdit extends PdsIcon {
  @state()
  icon = Pen;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
